<style lang="scss" scoped>
.logistic_total {
    display: flex;
    justify-content: space-between;
    & > span {
        width: 20%;
        text-align: center;
        padding: 10px;
        color: #fff;
        font-weight: bold;
    }
    .danger {
        background-color: #ed3f14;
    }
    .primary {
        background-color: #2db7f5;
    }
    .warning {
        background-color: #ff9900;
    }
    .success {
        background-color: #19be6b;
    }
}
.logistic_echart > div {
    height: 300px;
}
.logistic_echart .width-33per {
    width: 33%;
}

// .header {
//     display: flex;
//     justify-content: space-between;
// }
.top-header {
    display: flex;
    justify-content: space-between;
}
</style>


<template>
    <div class="logistic">
        <div class="header">
            <div class="top-header">
                <div class="left-search">
                    <vButton
                        v-for="item in timeChoice"
                        :key="item.value"
                        class="margin-right-10"
                        @click="setDate(item.value)"
                        >{{ item.label }}</vButton
                    >
                </div>

                <div class="right-button">
                    <vFormItem :label="$t('global.common.createdtime', { defaultValue: '创建时间' })" label-width="80" inline>
                        <vDatepicker
                            format="yyyy-mm-dd ~ yyyy-mm-dd"
                            v-model="createdate"
                            clearable
                        ></vDatepicker>
                    </vFormItem>
                    <vFormItem :label="$t('fbb.headlogistics.carrier_type', { defaultValue: '货代类型' })" label-width="80" inline>
                        <Select
                            style="width: 150px"
                            v-model="carrierType"
                            clearable
                        >
                            <Option :value="0">{{$t('fbb.headlogistics.carrier_type_standard', { defaultValue: '标准' })}}</Option>
                            <Option :value="1">{{$t('fbb.headlogistics.carrier_type_other', { defaultValue: '其他' })}}</Option>
                        </Select>
                    </vFormItem>
                    <vFormItem :label="$t('fbb.headlogistics.forwarder', { defaultValue: '货代公司' })" label-width="80" inline>
                        <Select
                            style="width: 150px"
                            v-model="forwarderId"
                            filterable
                            clearable
                        >
                            <Option
                                v-for="item in getCompanyList"
                                :key="item.key"
                                :value="item.value"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </vFormItem>
                    <Button
                        icon="ios-search"
                        class="margin-left-20"
                        type="primary"
                        :loading="isLoading"
                        @click="submit"
                        >{{$t('global.modal.confirm', { defaultValue: '确定' })}}</Button
                    >
                    <Button
                        icon="ios-arrow-down"
                        class="margin-left-10 margin-right-20"
                        type="default"
                        @click="showMore = !showMore"
                        >{{$t('global.common.btn_more', { defaultValue: '更多查询' })}}</Button
                    >
                </div>
            </div>
            <div v-if="showMore" class="second-header">
                <vFormItem :label="$t('fbb.headlogistics.designated_person', { defaultValue: '负责人' })" label-width="60" inline>
                    <!-- <Select style="width: 100px;" v-model="carrierType" clearable>
                        <Option :value="0">标准</Option>
                        <Option :value="1">其他</Option>
                    </Select> -->
                    <Input
                        style="width: 200px"
                        v-model="designatedPerson"
                    ></Input>
                </vFormItem>
                <vFormItem :label="$t('fbb.logistics.actual_sail_date', { defaultValue: '实际开船日期' })" label-width="110" inline>
                    <!-- <Select style="width: 100px;" v-model="carrierType" clearable>
                        <Option :value="0">标准</Option>
                        <Option :value="1">其他</Option>
                    </Select> -->
                    <vDatepicker
                        style="width: 200px"
                        type="daterange"
                        format="yyyy-mm-dd ~ yyyy-mm-dd"
                        v-model="actualSailAt"
                        clearable
                    ></vDatepicker>
                </vFormItem>
            </div>
        </div>
        <div class="logistic_total">
            <span
                v-for="(item, index) in billReport"
                :key="index"
                :class="item.theme"
                >{{ item.label }}: {{ item.value }}</span
            >
        </div>
        <div class="logistic_echart margin-top-30 margin-bottom-20 clearfix">
            <!-- echart -->
            <div class="echart_line width-50per pull-left"></div>
            <div class="echart_bar2 width-50per pull-left"></div>
            <div class="echart_bar width-100per pull-left"></div>
            <div class="echart_huogui width-100per pull-left"></div>
            <div class="echart_pei1 width-33per pull-left"></div>
            <div class="echart_pei2 width-33per pull-left"></div>
            <div class="echart_pei3 width-33per pull-left"></div>
        </div>
    </div>
</template>
<script>
import { HttpGetLogisticsPanel } from "@/service/logisticspanel";
import { mapState, mapGetters } from "vuex";
export default {
    data() {
        return {
            showMore: false,
            isLoading: true,
            carrierType: "",
            createdate: "",
            forwarderId: "",
            designatedPerson: "",
            actualSailAt: "",
            timeChoice: [
                {
                    label: this.$t('fbb.logistics.now_month', { defaultValue: "本月" }),
                    value: 0,
                },
                {
                    label: this.$t('fbb.logitiscs.last_month', { defaultValue: "上月" }),
                    value: -1,
                },
                {
                    label: this.$t('fbb.logistics.last_three_month', { defaultValue: "近三月" }),
                    value: -3,
                },
                {
                    label: this.$t('fbb.logistics.last_year', { defaultValue: "近一年" }),
                    value: -12,
                },
            ],
            //单据统计
            billReport: [
                {
                    label: this.$t('fbb.logistics.exception_order', { defaultValue: "异常单" }),
                    value: 0,
                    theme: "danger",
                },
                {
                    label: this.$t('fbb.logistics.total_order', { defaultValue: "总单量" }),
                    value: 0,
                    theme: "primary",
                },
                {
                    label: this.$t('fbb.logistics.not_finish', { defaultValue: "未完成" }),
                    value: 0,
                    theme: "warning",
                },
                {
                    label: this.$t('global.common.finished', { defaultValue: "已完成" }),
                    value: 0,
                    theme: "success",
                },
            ],
            formData: {
                exceptionQty: 0,
            },
            startday: "",
            endday: "",
        };
    },
    created() {
        const date = new Date();
        const bb = date.setMonth(date.getMonth());
        const aa = date.setMonth(0, 1);
        this.startday = this.changedate(aa);
        this.endday = this.changedate(bb);
        this.createdate = this.startday + " ~ " + this.endday;
        this.update(this.createdate);
    },
    computed: {
        ...mapGetters("dictionary", ["getCompanyList"]),
    },
    methods: {
        // 设置日期
        setDate(value) {
            this.createdate = "";
            const date = new Date();
            if (value === 0) {
                const bb = date.setMonth(date.getMonth());
                const aa = date.setMonth(date.getMonth(), 1);
                this.startday = this.changedate(aa);
                this.endday = this.changedate(bb);
            } else if (value === -1) {
                const bb = date.setMonth(date.getMonth(value), 0);
                const aa = date.setMonth(date.getMonth(value), 1);
                this.startday = this.changedate(aa);
                this.endday = this.changedate(bb);
            } else if (value === -3) {
                const bb = date.setMonth(date.getMonth());
                const aa = date.setMonth(date.getMonth() - 3);
                this.startday = this.changedate(aa);
                this.endday = this.changedate(bb);
            } else if (value === -12) {
                const bb = date.setMonth(date.getMonth());
                const aa = date.setMonth(date.getMonth(value) - 12);
                this.startday = this.changedate(aa);
                this.endday = this.changedate(bb);
            }

            this.submit();
        },
        changedate(num) {
            let newday = new Date(num);
            let year = newday.getFullYear();
            let month = newday.getMonth() + 1;
            let day = newday.getDate();
            month = month < 10 ? "0" + month : month;
            day = day < 10 ? "0" + day : day;
            let d = year + "-" + month + "-" + day;
            return d;
        },
        submit() {
            let daterange;
            // if (this.createdate != "") {
            //     daterange = this.createdate;
            // } else {
            //     daterange = this.startday + " ~ " + this.endday;
            // }
            daterange = this.createdate;
            this.isLoading = true;
            this.update(daterange);
        },
        update(value) {
            HttpGetLogisticsPanel({
                "search[BT_createdAt]": value,
                "search[EQ_carrierType]": this.carrierType,
                "search[EQ_forwarderId]": this.forwarderId,
                "search[EQ_designatedPerson]": this.designatedPerson,
                "search[BT_actualSailAt]": this.actualSailAt,
            }).then(
                (res) => {
                    this.formData = res.data;
                    this.handleData(res.data);
                    this.isLoading = false;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        handleData(data) {
            this.billReport[0].value = data.exceptionQty;
            this.billReport[1].value = data.totalQty;
            this.billReport[2].value = data.undoneQty;
            this.billReport[3].value = data.finishQty;

            // 物流单据趋势图
            // 进行排序
            let logisn1 = [],
                logisn2 = [],
                logisn3 = [],
                logisn4 = [];
            this.sortJson(data.oneYearQty, function (jsondata) {
                for (let key in jsondata) {
                    logisn1.push(jsondata[key].month);
                    logisn2.push(jsondata[key].totalQty);
                    logisn3.push(jsondata[key].throughQty);
                    logisn4.push(jsondata[key].transferQty);
                }
            });

            let order1 = [],
                order2 = [];
            for (let key1 in data.orderStatusMap) {
                
                order2.push(data.orderStatusMap[key1]);
            }
            order2 = this.compareFN(order2, "id").reverse();
            order2.map((item) => {
                order1.push(this.$t(`fbb.code.${item.name}`));
            });

            let delay1 = [],
                delay2 = [];
            for (let key2 in data.exOrderMap) {
                delay1.push(this.$t(`fbb.code.${key2}`));
                delay2.push(data.exOrderMap[key2]);
            }

            // 目的仓分布
            let waredata = [];

            for (let key3 in data.warehouseMap) {
                let json = {
                    name: key3,
                    value: data.warehouseMap[key3],
                };
                waredata.push(json);
            }
            waredata = this.compareFN(waredata, "value");

            // 货运分布方式
            let shipment = [];
            for (let key4 in data.transportTypeMap) {
                let json = {
                    name: this.$t(`fbb.code.${key4}`),
                    value: data.transportTypeMap[key4],
                };
                shipment.push(json);
            }
            shipment = this.compareFN(shipment, "value");

            // 贷代分布
            let carrier = [];
            for (let key4 in data.carrierNameMap) {
                let json = {
                    name: key4,
                    value: data.carrierNameMap[key4],
                };
                carrier.push(json);
            }
            carrier = this.compareFN(carrier, "value");

            // 货柜数量
            let containmonth = [],
                containqty = [];
            this.sortJson(data.oneYearContainerQty, function (jsondata) {
                for (let key in jsondata) {
                    containmonth.push(jsondata[key].month);
                    containqty.push(jsondata[key].totalQty);
                }
            });

            // 图像调用
            this.drawEchartLine({ logisn1, logisn2, logisn3, logisn4 });
            this.drawEchartBar1({ order1, order2 });
            this.drawEchartBar2({ delay1, delay2 });
            this.drawEchartPie1(waredata);
            this.drawEchartPie2(shipment);
            this.drawEchartPie3(carrier);
            this.drawEchartLine2({ containmonth, containqty });
        },
        // 根据某个对象属性排序
        compareFN(arr, property) {
            var i = 0;
            var j = 0;
            let t;
            for (i = 0; i < arr.length; i++) {
                for (j = 0; j < arr.length; j++) {
                    if (arr[i][property] > arr[j][property]) {
                        t = arr[i];
                        arr[i] = arr[j];
                        arr[j] = t;
                    }
                }
            }
            return arr;
        },
        // 时间排序
        sortJson(obj, callback) {
            var endValue, item, key, keyArray, keyArray2, o, _i, _len;
            endValue = {};
            keyArray = [];
            keyArray2 = [];
            for (key in obj) {
                o = {};
                o[key] = obj[key];
                keyArray.push(key);
            }
            keyArray2 = keyArray.sort();
            for (_i = 0, _len = keyArray2.length; _i < _len; _i++) {
                item = keyArray2[_i];
                endValue[item] = obj[item];
            }
            return typeof callback === "function" ? callback(endValue) : void 0;
        },
        drawEchartLine({ logisn1, logisn2, logisn3, logisn4 }) {
            const echart = Echarts.init(this.$el.querySelector(".echart_line"));
            // 绘制图表
            echart.setOption({
                title: {
                    text: this.$t('fbb.logistics.logistics_order_quanlity_chart', { defaultValue: "物流单据数量趋势图" }),
                    left: "center",
                },
                tooltip: {
                    trigger: "axis",
                },
                legend: {
                    top: 30,
                    left: "center",
                    data: [
                        this.$t('fbb.logistics.total_number', { defaultValue: "总数量" }),
                        this.$t('fbb.headlogistics.logistics_type_through', { defaultValue: "直达" }),
                        this.$t('fbb.logistics.transfer', { defaultValue: "转运" })
                    ],
                },
                xAxis: {
                    type: "category",
                    data: logisn1,
                },
                yAxis: {
                    type: "value",
                },
                series: [
                    {
                        name: this.$t('fbb.logistics.total_number', { defaultValue: "总数量" }),
                        data: logisn2,
                        type: "line",
                    },
                    {
                        name: this.$t('fbb.headlogistics.logistics_type_through', { defaultValue: "直达" }),
                        data: logisn3,
                        type: "line",
                    },
                    {
                        name: this.$t('fbb.logistics.transfer', { defaultValue: "转运" }),
                        data: logisn4,
                        type: "line",
                    },
                ],
            });
        },
        drawEchartBar1({ order1, order2 }) {
            const echart = Echarts.init(this.$el.querySelector(".echart_bar"));
            // 绘制图表
            echart.setOption({
                title: {
                    text: this.$t('fbb.logistics.wait_order', { defaultValue: "待跟进单据" }),
                    left: "center",
                },
                tooltip: { trigger: "axis" },
                xAxis: {
                    type: "category",
                    splitLine: { show: false },
                    data: order1,
                },
                yAxis: {},
                series: [
                    {
                        name: this.$t('fbb.logistics.total_number', { defaultValue: "总数量" }),
                        data: order2,
                        type: "bar",
                    },
                ],
            });
        },
        drawEchartBar2({ delay1, delay2 }) {
            const echart = Echarts.init(this.$el.querySelector(".echart_bar2"));
            // 绘制图表
            echart.setOption({
                title: {
                    text: this.$t('fbb.logistics.logistics_delay_order_number', { defaultValue: "物流延迟单据数量" }),
                    left: "center",
                },
                tooltip: { trigger: "axis" },
                xAxis: {
                    type: "category",
                    data: delay1,
                    axisLabel: {
                        interval: 0,
                    },
                },
                yAxis: {
                    type: "value",
                },
                series: [
                    {
                        name: this.$t('fbb.logistics.total_number', { defaultValue: "总数量" }),
                        data: delay2,
                        type: "bar",
                    },
                ],
            });
        },
        drawEchartPie1(waredata) {
            const echart = Echarts.init(this.$el.querySelector(".echart_pei1"));
            echart.setOption({
                title: {
                    text: this.$t('fbb.logistics.target_warehouse_set', { defaultValue: "目的仓分布" }),
                    left: "center",
                },
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b} : {c} ({d}%)",
                },

                legend: {
                    orient: "vertical",
                    left: 10,
                    top: 20,
                    itemGap: 15,
                    itemWidth: 10,
                    formatter: function (params) {
                        if (params.indexOf("(") == -1) {
                            return params;
                        } else {
                            return (
                                params.split("(")[0] +
                                "\n" +
                                "(" +
                                params.split("(")[1]
                            );
                        }
                    },
                },

                series: [
                    {
                        name: "",
                        type: "pie",
                        radius: "50%",
                        label: {
                            normal: {
                                show: false,
                                position: "center",
                            },
                        },
                        center: ["60%", "50%"],
                        data: waredata,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            });
        },
        drawEchartPie2(shipment) {
            const echart = Echarts.init(this.$el.querySelector(".echart_pei2"));
            echart.setOption({
                title: {
                    text: this.$t('fbb.logistics.deliver_methods_set', { defaultValue: "货运方式分布" }),
                    left: "center",
                },
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b} : {c} ({d}%)",
                },
                legend: {
                    orient: "vertical",
                    left: 10,
                    top: 20,
                    itemGap: 15,
                    itemWidth: 10,
                },
                series: [
                    {
                        name: "",
                        type: "pie",
                        radius: "50%",
                        label: {
                            normal: {
                                show: false,
                                position: "center",
                            },
                        },
                        // center: ["60%","50%"],
                        data: shipment,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            });
        },
        drawEchartPie3(carrier) {
            const echart = Echarts.init(this.$el.querySelector(".echart_pei3"));
            echart.setOption({
                title: {
                    text: this.$t('fbb.logistics.deliver_use_set', { defaultValue: "贷代使用分布" }),
                    left: "center",
                },
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b} : {c} ({d}%)",
                },
                legend: {
                    orient: "vertical",
                    left: 10,
                    top: 20,
                    itemGap: 15,
                    itemWidth: 10,
                },
                series: [
                    {
                        name: "",
                        type: "pie",
                        radius: "50%",
                        data: carrier,
                        label: {
                            normal: {
                                show: false,
                                position: "center",
                            },
                        },
                        // center: ["60%","50%"],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            });
        },
        drawEchartLine2({ containmonth, containqty }) {
            const echart = Echarts.init(
                this.$el.querySelector(".echart_huogui")
            );
            // 绘制图表
            echart.setOption({
                title: {
                    text: this.$t('fbb.logistics.cargo_box_number_count', { defaultValue: "货柜数量统计" }),
                    left: "center",
                },
                tooltip: {
                    trigger: "axis",
                },
                legend: {
                    top: 30,
                    left: "center",
                    data: [
                        this.$t('fbb.logistics.total_number', { defaultValue: "总数量" }),
                        this.$t('fbb.headlogistics.logistics_type_through', { defaultValue: "直达" }),
                        this.$t('fbb.logistics.transfer', { defaultValue: "转运" })
                    ],
                },
                xAxis: {
                    type: "category",
                    data: containmonth,
                },
                yAxis: {
                    type: "value",
                },
                series: [
                    {
                        name: this.$t('fbb.logistics.total_number', { defaultValue: "总数量" }),
                        data: containqty,
                        type: "line",
                    },
                ],
            });
        },
    },
};
</script>
